import { Box, Flex, IconButton, Text, Stack, Divider, Image } from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import logo from "../assets/logo/mp_logo_white.png";

type FooterProps = { copyright?: string };

const Footer = ({ copyright = "© 2026 Miller Productions Kft. Minden jog fenntartva" }: FooterProps) => (
  <Box as="footer" bg="chalk.200" color="ink.900">
    <Divider borderColor="chalk.400" />
    <Flex
      direction={["column", "row"]}
      align={["center", "center"]}
      justify="space-between"
      maxW="1400px"
      mx="auto"
      px={{ base: 5, md: 8 }}
      py={8}
      textAlign={["center", "left"]}
      gap={4}
    >
      <Flex direction="column" align={["center", "flex-start"]} gap={2}>
        <Image w={120} src={logo} alt="Miller Productions logó" filter="brightness(0)" opacity={0.85} />
        <Text color="slate.500" fontSize="sm">
          {copyright}
        </Text>
      </Flex>

      <Stack direction="row" spacing={3}>
        <IconButton
          target="_blank"
          rel="noopener noreferrer"
          as="a"
          href="https://www.linkedin.com/company/miller-productions"
          icon={<FaLinkedin />}
          aria-label="LinkedIn"
          variant="ghost"
          color="slate.500"
          _hover={{ color: "lime.700", bg: "chalk.50" }}
        />
      </Stack>
    </Flex>
  </Box>
);

export default Footer;
